import Moment from "react-moment/dist/index";
import {formatDuration} from "../Utils/Utils";
import React from "react";

const OrderStatus = function(props) {
    return (
        <div>
            Date:&nbsp;<Moment unix>{props.modified_at}</Moment>&nbsp;
            Device: {props.dev_uuid}&nbsp;
            Amount: {props.amount/100.}&nbsp;{props.currency}&nbsp;
            Time added: {formatDuration(props.sec_added)}&nbsp;
            Time available: {formatDuration(props.sec_granted)}&nbsp;
            Paid by: {props.method_of_payment}&nbsp;
            <a href={props.receipt_url}  target="_blank" rel="noopener noreferrer">Receipt</a>&nbsp;
            Status: {props.status}
        </div>
    );
};

export default OrderStatus;
